import {Box, Typography} from "@material-ui/core"
import {useStyles} from "./styles"

export function SectionHeader({ icon, title, subtitle }) {
  const classes = useStyles()
  return (
    <Box className={classes.sectionHeader}>
      {icon}
      <Box>
        <Typography variant="h5">{title}</Typography>
        <Typography variant="body2" color="textSecondary">{subtitle}</Typography>
      </Box>
    </Box>
  )
}